export default __webpack_public_path__ + "static/media/diagram.1aca5ab9.png";